import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { LogOut, User } from "react-feather";
import { useHistory } from "react-router";
import { translate } from "react-switch-lang";
import man from "../../assets/images/dashboard/profile.jpg";
import Translate from "../translate/translate";
import hasRoles from "../../security/hasRoles";
import AgrisudLogo from "../../assets/images/logo/logo-agrisud-cropped2.jpg";
import styles from "./rightbar.module.scss";
import { useSelector } from "react-redux";

const Rightbar = props => {
  const [name, setName] = useState("");
  const [setMoonlight] = useState(false);
  const keycloak = useKeycloak().keycloak;
  const history = useHistory();
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const currentLang = useSelector(state => state.language.currentLang);

  useEffect(() => {
    setName(localStorage.getItem("Name"));
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true);
    }
    if (keycloak.authenticated) {
      keycloak.loadUserInfo().then(info => {
        setName(info.name);
        // setMainRole(keycloak.hasResourceRole("ROLE_MEDIATHEQUE_ADMIN") ? Role.ROLE_MEDIATHEQUE_ADMIN : "");
      });
    }
    // eslint-disable-next-line
  }, []);
  const redirectContactUs = () => {
    const win = window.open(currentLang === "fr" ?  "https://www.agrisud.org/web/contact/" : "https://www.agrisud.org/web/en/contact", "_blank");
    win.focus();
  };

  const redirectToStatistic = () => {
    history.push("/statistic");
  };

  return (
    <div className={styles["agrisud-navbar"]}>
      <div className={styles["agrisud-nav-menus-logo"]}>
        <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
          <img className={styles["nav-image"]} src={AgrisudLogo} alt="" />
        </a>
      </div>

      <div className={`nav-right ${styles["agrisud-navbar-items"]} right-header`}>
        <ul className={`${styles["agrisud-nav-menus"]} nav-menus`}>
          <li className="language-nav">
            <Translate />
          </li>
          {keycloak.authenticated && window.outerWidth > 769 && (
            <li className="profile-nav onhover-dropdown p-0">
              <div className={`${styles["custom-media"]} media profile-media`}>
                <img className="b-r-10" src={man} alt="" />
                <div className="media-body">
                  <span>{keycloak.authenticated ? name : "name"}</span>
                  <p className={"mb-0 font-roboto"}>
                    {props.t("auth_roles_mediatheque_admin")} <i className="middle fa fa-angle-down"></i>
                  </p>
                </div>
              </div>
              <ul className="profile-dropdown onhover-show-div">
                <li onClick={() => (window.location = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`)}>
                  <User />
                  <span> {props.t("label_account")}</span>
                </li>
                <li
                  onClick={() => {
                    history.push("/");
                    keycloak.logout();
                  }}
                >
                  <LogOut />
                  <span>{props.t("label_logout")}</span>
                </li>
              </ul>
            </li>
          )}
        </ul>

        <div className={styles["agrisud-navbar-links"]}>
          <div className={styles["agrisud-navbar-links-slugan"]}>
            <h5 onClick={() => history.push(`/`)} className={styles["agrisud-navbar-slugan"]}>
              {props.t("title_mediatheque")}
            </h5>
          </div>
          {window.outerWidth > 769 && (
            <div className={styles["agrisud-navbar-links-items"]}>
              <div className={styles["agrisud-navbar-links-item"]}>
                <span>
                  <a href={"https://www.agrisud.org/e-learning"} target="_blank" rel="noreferrer">
                    E-learning
                  </a>
                </span>
              </div>
              <div className={styles["agrisud-navbar-links-item"]}>
                {!hasRoleAdmin ? (
                  <span className={styles["agrisud-navbar-aide"]}>
                    <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
                      Agrisud.org
                    </a>
                  </span>
                ) : (
                  <span clas onClick={redirectToStatistic}>
                    {props.t("title_statistic")}
                  </span>
                )}
              </div>
              <div>
                {!hasRoleAdmin && (
                  <span className={styles["agrisud-navbar-aide"]} onClick={redirectContactUs}>
                    {"Contact"}
                  </span>
                )}
                {hasRoleAdmin && (
                  <span className={styles["agrisud-navbar-aide"]} onClick={() => history.push(`/parametre`)}>
                    {props.t("title_setting")}
                  </span>
                )}
              </div>
            </div>
          )}
          {window.outerWidth <= 769 && (
            <>
              <input className={styles["toggle-menu"]} id="toggle-menu" type="checkbox" />
              <nav className={styles["nav-vertical-menu"]}>
                <ul>
                  <li>
                    <a color="black" href={"https://www.agrisud.org/e-learning"} target="_blank" rel="noreferrer">
                      E-learning
                    </a>
                  </li>
                  {!hasRoleAdmin ? (
                    <>
                      <li>
                        <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
                          Agrisud.org
                        </a>
                      </li>
                      <li>
                        <span onClick={redirectContactUs}>Contact</span>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <span onClick={redirectToStatistic}>{props.t("title_statistic")}</span>
                      </li>
                      <li>
                        <span className={styles["agrisud-navbar-aide"]} onClick={() => history.push(`/parametre`)}>
                          {props.t("title_setting")}
                        </span>
                      </li>
                      <li onClick={() => (window.location = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`)}>
                        <User />
                        <span className="m-l-5">{props.t("label_account")}</span>
                      </li>
                      <li
                        onClick={() => {
                          history.push("/");
                          keycloak.logout();
                        }}
                      >
                        <LogOut />
                        <span className="m-l-5">{props.t("label_logout")}</span>
                      </li>
                    </>
                  )}
                </ul>
              </nav>
              <label className={styles["button-toggle-menu"]} htmlFor="toggle-menu">
                <i className="fa fa-bars"></i>
              </label>
              <label className={styles["overlay"]} htmlFor="toggle-menu"></label>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default translate(Rightbar);
